// extracted by mini-css-extract-plugin
export var searchHeader = "_3q-0";
export var searchHeaderDark = "_3q-1";